export default __webpack_public_path__ + "static/media/gallery-img.f1a4be34.jpeg";